// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../css-loader/dist/cjs.js!./dirty-diff-decorator.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************
 * Copyright (C) 2018 TypeFox and others.
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * This Source Code may also be made available under the following Secondary
 * Licenses when the conditions for such availability set forth in the Eclipse
 * Public License v. 2.0 are satisfied: GNU General Public License, version 2
 * with the GNU Classpath Exception which is available at
 * https://www.gnu.org/software/classpath/license.html.
 *
 * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0
 ********************************************************************************/

.monaco-editor .dirty-diff-added-line {
  border-left: 3px solid var(--theia-editorGutter-addedBackground);
  transition: opacity 0.5s;
}
.monaco-editor .dirty-diff-added-line:before {
  background: var(--theia-editorGutter-addedBackground);
}
.monaco-editor .margin:hover .dirty-diff-added-line {
  opacity: 1;
}

.monaco-editor .dirty-diff-removed-line:after {
  border-left: 4px solid var(--theia-editorGutter-deletedBackground);
  transition: opacity 0.5s;
}
.monaco-editor .dirty-diff-removed-line:before {
  background: var(--theia-editorGutter-deletedBackground);
}
.monaco-editor .margin:hover .dirty-diff-removed-line {
  opacity: 1;
}

.monaco-editor .dirty-diff-modified-line {
  border-left: 3px solid var(--theia-editorGutter-modifiedBackground);
  transition: opacity 0.5s;
}
.monaco-editor .dirty-diff-modified-line:before {
  background: var(--theia-editorGutter-modifiedBackground);
}
.monaco-editor .margin:hover .dirty-diff-modified-line {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/node_modules/@theia/scm/src/browser/style/dirty-diff.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;iFAciF;;AAIjF;EACE,gEAAgE;EAChE,wBAAwB;AAC1B;AACA;EACE,qDAAqD;AACvD;AACA;EACE,UAAU;AACZ;;AAEA;EACE,kEAAkE;EAClE,wBAAwB;AAC1B;AACA;EACE,uDAAuD;AACzD;AACA;EACE,UAAU;AACZ;;AAEA;EACE,mEAAmE;EACnE,wBAAwB;AAC1B;AACA;EACE,wDAAwD;AAC1D;AACA;EACE,UAAU;AACZ","sourcesContent":["/********************************************************************************\n * Copyright (C) 2018 TypeFox and others.\n *\n * This program and the accompanying materials are made available under the\n * terms of the Eclipse Public License v. 2.0 which is available at\n * http://www.eclipse.org/legal/epl-2.0.\n *\n * This Source Code may also be made available under the following Secondary\n * Licenses when the conditions for such availability set forth in the Eclipse\n * Public License v. 2.0 are satisfied: GNU General Public License, version 2\n * with the GNU Classpath Exception which is available at\n * https://www.gnu.org/software/classpath/license.html.\n *\n * SPDX-License-Identifier: EPL-2.0 OR GPL-2.0-only WITH Classpath-exception-2.0\n ********************************************************************************/\n\n@import \"dirty-diff-decorator.css\";\n\n.monaco-editor .dirty-diff-added-line {\n  border-left: 3px solid var(--theia-editorGutter-addedBackground);\n  transition: opacity 0.5s;\n}\n.monaco-editor .dirty-diff-added-line:before {\n  background: var(--theia-editorGutter-addedBackground);\n}\n.monaco-editor .margin:hover .dirty-diff-added-line {\n  opacity: 1;\n}\n\n.monaco-editor .dirty-diff-removed-line:after {\n  border-left: 4px solid var(--theia-editorGutter-deletedBackground);\n  transition: opacity 0.5s;\n}\n.monaco-editor .dirty-diff-removed-line:before {\n  background: var(--theia-editorGutter-deletedBackground);\n}\n.monaco-editor .margin:hover .dirty-diff-removed-line {\n  opacity: 1;\n}\n\n.monaco-editor .dirty-diff-modified-line {\n  border-left: 3px solid var(--theia-editorGutter-modifiedBackground);\n  transition: opacity 0.5s;\n}\n.monaco-editor .dirty-diff-modified-line:before {\n  background: var(--theia-editorGutter-modifiedBackground);\n}\n.monaco-editor .margin:hover .dirty-diff-modified-line {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
